import React from "react";
import { Link } from "react-router-dom";
import "../styles/pages.css";

export default function WorkAlongsideUs() {
  React.useEffect(() => { window.scrollTo({ top: 0 }); }, []);
  return (
    <div className="kmr-page case-study-wrap" data-testid="work-alongside-page">
      <div className="case-back">
        <Link to="/" data-testid="alongside-back-link">← Back to Komorebi</Link>
      </div>
      <iframe
        title="Join the mission — Komorebi"
        src="/work-alongside-us.html"
        className="case-study-iframe"
        data-testid="work-alongside-iframe"
      />
    </div>
  );
}
